import type { UserMoneyMetadata } from '../types/users.types';

export function parseUserAmountMinor(value: string, money: UserMoneyMetadata): number | null {
  const exponent = money.currency_exponent;
  if (exponent !== 0 && exponent !== 2) return null;
  const trimmed = value.trim();
  if (!(exponent === 0 ? /^\d+$/ : /^\d+(\.\d{1,2})?$/).test(trimmed)) return null;
  const [whole, fraction = ''] = trimmed.split('.');
  const minor = Number(whole + fraction.padEnd(exponent, '0'));
  return Number.isSafeInteger(minor) && minor > 0 ? minor : null;
}

export function formatUserMoney(minor: number, money: UserMoneyMetadata, signed = false): string {
  if (!Number.isSafeInteger(minor) || ![0, 2].includes(money.currency_exponent)) return '—';
  const exponent = money.currency_exponent;
  const digits = String(Math.abs(minor)).padStart(exponent + 1, '0');
  const amount = exponent ? `${digits.slice(0, -exponent)}.${digits.slice(-exponent)}` : digits;
  const sign = minor < 0 ? '-' : signed && minor > 0 ? '+' : '';
  return `${sign}${money.currency_symbol || money.currency}${amount}`;
}

export function userMarketLabel(money: UserMoneyMetadata): string {
  const label = money.market_id === 'CN' ? '中国' : money.market_id === 'VN' ? '越南' : money.market_id;
  return `${label} · ${money.currency}`;
}

export function userAmountPlaceholder(money: UserMoneyMetadata): string {
  return `金额（${money.currency}），例如 ${money.currency_exponent === 0 ? '10000' : '10.00'}`;
}

export function userAmountError(money: UserMoneyMetadata): string {
  return money.currency_exponent === 0 ? '请输入大于 0 的整数金额' : '请输入大于 0 的金额，最多两位小数';
}
